var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"people-select"},_vm._l((_vm.max),function(index){return _c('svg-icon',{key:("person_" + (index - 1)),staticClass:"person",class:{
            selected: _vm.amount === _vm.max - (index - 1),
        },attrs:{"height":"90","width":"56","icon":"person","color":"#798DA6"},on:{"click":function () { return _vm.onSelect(index - 1); }}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }